import { useCallback, useEffect, useState } from 'react';

import {
  useGetPolicyFleetCertificates,
  useGetPolicyGroupMedicalCertificates
} from '../policy.slice';

export function useSetCertificatePolicyCount(
  entityID: string | undefined,
  policyType: string | undefined,
  lineCode: string | number | undefined
) {
  const [getGroupMedicalCertificates] = useGetPolicyGroupMedicalCertificates();
  const [getFleetCertificates] = useGetPolicyFleetCertificates();
  const [certificatePolicyCount, setCertificatePolicyCount] = useState<
    number | undefined
  >(undefined);

  const lineCodeNum = Number(lineCode);

  const fetchCertificateCount = useCallback(async () => {
    if (
      !entityID ||
      policyType !== 'GROUP' ||
      ![3, 4, 51].includes(lineCodeNum)
    ) {
      setCertificatePolicyCount(undefined);

      return;
    }

    const paginationVars = {
      policyID: entityID,
      pagination: { pageNumber: 1, pageSize: 1 },
      keyword: ''
    };

    try {
      if (lineCodeNum === 3) {
        const { data } = await getGroupMedicalCertificates({
          variables: paginationVars
        });
        setCertificatePolicyCount(
          data?.production?.getPolicyCertificatePaginated?.paging?.totalCount ??
            0
        );
      } else {
        const { data } = await getFleetCertificates({
          variables: paginationVars
        });
        setCertificatePolicyCount(
          data?.production?.groupFleetCertificatesForListing?.paging
            ?.totalCount ?? 0
        );
      }
    } catch {
      setCertificatePolicyCount(0);
    }
  }, [entityID, policyType, lineCodeNum]);

  useEffect(() => {
    fetchCertificateCount();
  }, [fetchCertificateCount]);

  return certificatePolicyCount;
}
